module.exports = __webpack_public_path__ + "static/media/data-science.36b23ff2.svg";